exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-image[data-v-d98f5a08]{position:relative}.profile-image .avatar-edit[data-v-d98f5a08]{position:absolute;bottom:20px;left:140px}.profile-image .avatar[data-v-d98f5a08]{background:var(--bg-dash)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d98f5a08","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/settings/profile.vue
// module id = 6PWI
// module chunks = 1